import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router/index'
import 'amfe-flexible'
import 'vant/lib/index.css'
import drag from '@/directive/dragDiv'
// 点击前判断是否有网络
import onlineClick from '@/directive/onLine'
import db from '@/utils/db'
Vue.prototype.db = db
import {
  Field,
  NavBar,
  Toast,
  RadioGroup,
  Radio,
  DatetimePicker,
  Popup,
  Button,
  List,
  CellGroup,
  Cell,
  Search,
  SidebarItem,
  Sidebar,
  Tabbar,
  TabbarItem,
  Picker,
  Checkbox,
  CheckboxGroup,
  IndexBar,
  IndexAnchor,
  Tab,
  Tabs,
  Icon,
  Swipe,
  SwipeItem,
  Overlay,
  Stepper,
  CountDown,
  PullRefresh,
  Dialog,
  ActionSheet,
  Image as VanImage,
  Rate,
  Uploader,
  ImagePreview,
  Tag,
  Empty
} from 'vant'
Vue.use(Field)
  .use(NavBar)
  .use(Uploader)
  .use(Toast)
  .use(RadioGroup)
  .use(Radio)
  .use(DatetimePicker)
  .use(Popup)
  .use(Button)
  .use(List)
  .use(CellGroup)
  .use(Cell)
  .use(Search)
  .use(SidebarItem)
  .use(Icon)
  .use(Sidebar)
  .use(TabbarItem)
  .use(Tabbar)
  .use(Picker)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(IndexBar)
  .use(IndexAnchor)
  .use(Tab)
  .use(Tabs)
  .use(drag)
  .use(onlineClick)
  .use(Swipe)
  .use(SwipeItem)
  .use(Overlay)
  .use(Stepper)
  .use(CountDown)
  .use(onlineClick)
  .use(Swipe)
  .use(SwipeItem)
  .use(PullRefresh)
  .use(Dialog)
  .use(ActionSheet)
  .use(Uploader)
  .use(VanImage)
  .use(Rate)
  .use(ImagePreview)
  .use(Tag)
  .use(Empty)
Vue.config.productionTip = false
import "@/utils/index.umd.js";
window.$hyjkLoggerSdk = new hyjkLoggerSdk({
  env: process.env.VUE_APP_LOGGERENV,
  appName:"saas-patient-vue",
  userInfo: {
    osType: "H5",
  }
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
